import React from 'react';
import { motion, Variants } from 'framer-motion';
import arbventureIntroductionLaptop from '../../../assets/images/arbventure/introduction_laptop.webp';
import Constants from '../../../app/utils/constants';
import colors from '../../theme/color';

const IntroductionSection = () => {
  const { arbventureIntroduction } = Constants;

  const imageVariant: Variants = {
    hidden: { opacity: 0, x: -150 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: 'easeIn' },
    },
  };

  const textVariant: Variants = {
    hidden: { opacity: 0, x: 150 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: 'easeIn' },
    },
  };

  return (
    <section className="relative w-full overflow-hidden 2xl:pb-10">
      <div className="w-full px-[20px] md:px-[40px] lg:px-[70px]">

        {/* MAIN LAYOUT */}
        <div className="flex flex-col items-center md:gap-[30px] md:flex-row lg:justify-between lg:gap-[60px]">

          {/* LEFT IMAGE */}
          <motion.div
            variants={imageVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            className="relative flex w-full justify-center lg:w-[55%]"
          >
            {/* GLOW */}
            <div
              className="absolute left-[50%] top-[45%] z-0 h-[300px] w-[300px] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[80px] xl:h-[420px] xl:w-[420px]"
              style={{
                backgroundImage:
                  'radial-gradient(circle, rgba(95,153,55,0.7) 0%, rgba(95,153,55,0.35) 45%, rgba(95,153,55,0) 80%)',
              }}
            />

            {/* FLOATING IMAGE */}
            <motion.img
              src={arbventureIntroductionLaptop}
              alt="ARB Venture dashboard preview"
              animate={{
                y: [0, -20, 0, 20, 0],
              }}
              transition={{
                duration: 6,
                repeat: Infinity,
                ease: 'easeInOut',
              }}
              className="
                relative z-10 object-contain
                w-[300px] h-[300px]
                md:w-[450px] md:h-[450px]
                lg:w-[500px] lg:h-[450px]
                xl:w-[700px] xl:h-[700px]
                2xl:w-[1100px] 2xl:h-[850px]
              "
            />
          </motion.div>

          {/* RIGHT CONTENT */}
          <motion.div
            variants={textVariant}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            className="w-full text-center lg:w-[55%] lg:text-left"
          >
            {/* BADGE */}
            <div
              className="inline-flex items-center justify-center px-[28px] py-[14px]"
              style={{ backgroundColor: colors.arbVentureAccent }}
            >
              <span className="font-gilroy-bold text-[32px] leading-none text-white lg:text-[35px] xl:text-[52px] 2xl:font-[80px]">
                {arbventureIntroduction.badgeText}
              </span>
            </div>

            {/* DESCRIPTION */}
            <p
              className="mt-[28px] xl:w-[90%] font-gilroy-medium text-[18px] opacity-80 md:text-[20px] lg:text-[22px] lg:leading-8 xl:text-[26px] xl:leading-[40px] 2xl:text-[30px]"
              style={{ color: colors.arbVentureTextMuted }}
            >
              {arbventureIntroduction.description}
            </p>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default IntroductionSection;